import Grid from '@mui/material/Grid';
import LeadViewRight from 'src/features/leads/view/LeadViewRight';
import FiltersAndGrouping from 'src/features/leads/list/FiltersAndGrouping';
import EditLeadView from 'src/features/leads/view/EditLeadView';
import FilterContainer from 'src/features/common/FilterContainer';
import LeadsList from 'src/features/leads/list/LeadsList';
import ByCountryList from 'src/features/leads/list/ByCountryList';
import { LeadScreenStore, GroupType, ViewType, FilterSingleLead } from 'src/stores/LeadStore';
import { OptionWithSelect } from '../features/autocomplete/types';
import { useEffect, useState } from 'react';
import { IconButton } from '@mui/material';
import SimpleDialog from '../features/common/SimpleDialog';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LeadFilterBadges from '../features/filters/LeadFilterBadges';
import SearchComponent from '../features/filters/SearchComponent';
import LeadSearch from '../features/filters/leads/LeadSearch';
import { Filter, FilterType } from '../features/filters/FilterTypes';
import { v4 as uuid } from 'uuid';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TableChartIcon from '@mui/icons-material/TableChart';
import LeadGridView from '../features/leads/list/LeadGridView';
import { leadEndpoints } from '../configs/endpoints';
import TableRowsIcon from '@mui/icons-material/TableRows';

const LeadsScreen = () => {
    const groupBy = LeadScreenStore.useState((s) => s.groupBy);
    const selectedView = LeadScreenStore.useState((s) => s.selectedView);
    const filterSingleLead = FilterSingleLead.useState((s) => s.filterSingleLead);
    const [viewMode, setViewMode] = useState<'card' | 'table'>('table');

    const [filter, setFilter] = useState({
        id: uuid(),
        description: '',
        searchTerm: '',
        options: [],
        activityDate: 'any',
        filterType: FilterType.User,
    } as Filter);
    const [filtersOpen, setFiltersOpen] = useState(false);

    useEffect(() => {
        LeadScreenStore.update((s) => {
            s.selectedLeadCard = null;
        });
    }, []);

    //<FilterContainer title="Filters & Grouping" subTitle="Please select your filters below" defaultOpen={true}>
    //<FiltersAndGrouping />
    //</FilterContainer>

    const onShowFilters = () => {
        setFiltersOpen(true);
    };

    const onCloseFilter = () => {
        setFiltersOpen(false);
    };

    const onFiltersChanged = (newFilter: Filter) => {
        setFilter(newFilter);
    };

    //<LeadFilterBadges filters={filters} />
    //<IconButton onClick={onShowFilters} title="filters">
    //    <FilterAltIcon />
    //</IconButton>
    //<SimpleDialog open={filtersOpen} onClose={onCloseFilter}>
    //    <LeadFilters onFiltersChanged={onFiltersChanged} />
    //</SimpleDialog>
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    {!filterSingleLead && <LeadSearch onChange={onFiltersChanged} />}
                </Grid>
                <Grid item xs={12}>
                    <IconButton title="Card View" onClick={() => setViewMode('card')}>
                        <DashboardIcon />
                    </IconButton>
                    <IconButton title="Table View" onClick={() => setViewMode('table')}>
                        <TableRowsIcon />
                    </IconButton>
                </Grid>
                {viewMode === 'card' && (
                    <>
                        <Grid item xs={12} md={5} lg={5}>
                            {groupBy === GroupType.None && <LeadsList filter={filter} searchTerm={filter.searchTerm} />}
                            {groupBy === GroupType.Country && !filterSingleLead && <ByCountryList />}
                        </Grid>
                        <Grid item xs={12} md={7} lg={7}>
                            <LeadViewRight />
                        </Grid>
                    </>
                )}

                {viewMode === 'table' && (
                    <Grid item xs={12}>
                        <LeadGridView filter={filter} searchTerm={filter.searchTerm} />
                        <LeadViewRight />
                    </Grid>
                )}
            </Grid>

            {selectedView == ViewType.Edit && <EditLeadView />}
        </>
    );
};

LeadsScreen.guestGuard = false;
LeadsScreen.authGuard = true;

export { LeadsScreen };

export default LeadsScreen;
